import {makeAutoObservable} from "mobx";
import {KpiShippingLoadParams} from "./commons";
import {WeighingListItemDto} from "../../api/kpi";
import {api} from "../../api";

interface ItemType { date: string, incoming: number, backlog: number }

class KpiWeighingDashboardStore {
    get chartData(): ItemType[] {
        return this._chartData;
    }

    set chartData(value: ItemType[]) {
        this._chartData = value;
    }
    get data(): WeighingListItemDto[] {
        return this._data;
    }

    private set data(value: WeighingListItemDto[]) {
        this._data = value;
    }

    private _chartData: ItemType[] = []
    private _data: WeighingListItemDto[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load(query: KpiShippingLoadParams) {
        try {
            const result = await api.kpi.api.listWeighings(query)
            this.data = result.data.items || []
        } catch (ignored) {
            //TODO: mark as error
            this.data = []
        }
        this.buildChartData()

    }

    private buildChartData() {
        const groupedByDate: Record<string, ItemType> = {}
        this.data.forEach(e => {
            const date = e.date
            const amount = e.amount
            const type = e.type
            if (
                !(date && amount !== undefined && type)
            ) {
                return
            }
            if (!groupedByDate[date]) {
                groupedByDate[date] = {
                    date,
                    incoming: 0,
                    backlog: 0
                };
            }

            if (type === 'INCOMING') {
                groupedByDate[date].incoming = groupedByDate[date].incoming + amount
            }

            if (type === 'BACKLOG') {
                groupedByDate[date].backlog = groupedByDate[date].backlog + amount
            }
        })

        this.chartData = Object.values(groupedByDate)
            .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
            .map(a => {

                return {...a, date: (new Date(a.date)).toLocaleDateString('de')}
            })
    }
}

const kpiWeighingDashboardStore = new KpiWeighingDashboardStore()

export {
    kpiWeighingDashboardStore
}
